/*---------------------------------------------------------*\
 * News12ButtonController
\*---------------------------------------------------------*/
class News12ButtonController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor() {
    this.name = 'news12Button';
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  keyDown(event) {
    this.onKeydown({ event });
  }

  keyUp(event) {
    this.onKeyup({ event });
  }
}

export default News12ButtonController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/news12Button/news12Button.controller.js
 **/